module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jDytkF/tc-custom/9781426831195.jpg?1725149283181",
      "alt": "This image is the cover for the book Desert King's Pregnant Bride, Unexpected Babies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Desert King's Pregnant Bride, Unexpected Babies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author “captures her readers with a lure as magical as tales from Arabian Nights . . . a timeless masterpiece” ("), _c('i', [_vm._v("Romance Junkies")]), _vm._v(", 4.5 ribbons).")]), _c('br'), _c('br'), _vm._v("Sheikh Khalid Bin Shareef has vowed never to get entangled with virgins. But innocent Maggie is too hard to resist—and he takes her . . . "), _c('br'), _c('br'), _vm._v("The next morning she disappears. But Maggie is unfinished business, and he has her sent to his kingdom. There they discover the consequence of their night of passion."), _c('br'), _c('br'), _vm._v("Marriage is the only answer—but it must be one with no emotions, no expectations of love. Maggie will take her rightful place by the sheikh’s side . . . and in his bed!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Annie West\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Annie has devoted her life to an intensive study of charismatic heroes who cause the best kind of trouble in the lives of their heroines. As a sideline she researches locations for romance, from vibrant cities to desert encampments and fairytale castles. Annie lives in eastern Australia with her hero husband, between sandy beaches and gorgeous wine country. She finds writing the perfect excuse to postpone housework. To contact her or join her newsletter, visit www.annie-west.com ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0